// @flow

import React, { createContext, useContext } from 'react'
import { useSelector } from 'react-redux'

import { getPromoCustomErrorEnabled } from '@alphaott/app-main/selectors'
import { useModalController } from '@alphaott/smart-tv-common'

import { ContentUnavailable } from '../components/ContentUnavailable'

const ContentAccessContext = createContext<Object>(null)

export function useContentAccessContext() {
  const context = useContext(ContentAccessContext)

  if (!context) {
    throw new Error('useContentAccessContext must be used within a ContentAccessProvider')
  }

  return context
}

export type ContentAccessProviderProps = {
  children: any,
}

export const ContentAccessProviderInner = ({ children }: ContentAccessProviderProps) => {
  const modalController = useModalController()

  return (
    <ContentAccessContext.Provider value={modalController}>
      {children}

      <ContentUnavailable {...modalController} />
    </ContentAccessContext.Provider>
  )
}

export const ContentAccessProvider = ({ children }: ContentAccessProviderProps) => {
  const isPromoCustomErrorEnabled = useSelector(getPromoCustomErrorEnabled)

  if (isPromoCustomErrorEnabled) {
    return <ContentAccessProviderInner>{children}</ContentAccessProviderInner>
  }

  return children
}

export default ContentAccessProvider
